module.exports = new __parcel__URL__("ww-animated-promo-packages.3510c603.gif").toString();